import { flow, makeObservable, observable } from 'mobx';
import { SearchBarService } from '../services/searchBarService';
import { CompanyDropdownStore } from './companyDropdownStore';
import { GlobalStore } from './globalStore';

const form = {
  fields: {
    username: {
      value: '',
      error: null,
      rule: 'required',
    },
    password: {
      value: '',
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export interface SearchResult {
  loanId: number;
  lenderCompanyId: number;
  dealName: string;
  lender: string;
  status?: string;
  capitalProvider?: string;
  // Only populated for External Capital rows: the platform loan's native identifier (e.g. "L21").
  loanNumber?: string;
}

export class SearchBarStore {
  private globalStore: GlobalStore;
  private companyDropdownStore: CompanyDropdownStore;
  private searchBarService: SearchBarService;
  public showSearch: boolean;

  loading = false;
  searchResults: SearchResult[] = [];

  constructor(globalStore, companyDropdownStore) {
    this.globalStore = globalStore;
    this.companyDropdownStore = companyDropdownStore;
    this.searchBarService = new SearchBarService();
    makeObservable(this, {
      loading: observable,
      searchResults: observable,
      searchLoans: flow,
      setShowSearch: flow,
      showSearch: observable,
    });
  }

  reset() {
    this.searchResults = [];
  }

  *searchLoans(term) {
    try {
      this.loading = true;
      if (this.globalStore.showUnifiedLoans) {
        const response = yield this.searchBarService.searchLoansUnified(term);
        this.searchResults = response.data.data.rows;
      } else {
        const response = yield this.searchBarService.searchLoans(term);
        this.searchResults = response.data.data.rows;
      }
      this.loading = false;
    } catch (e) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while retrieving the search results',
      });
    }
  }

  setShowSearch(value) {
    this.showSearch = value;
  }
}
